import { useQuery } from "@tanstack/react-query";
import { UserAPI } from "@repo/api/user";
import { OrdersAPI } from "@repo/api/orders";
import { userKeys } from "../keys";
import { useRefetchOnToken } from "./useRefetchOnToken";

/** 用户公开资料变化不频繁，5 分钟内同一 uid 不重复请求 */
const PROFILE_STALE_TIME = 5 * 60_000;

/**
 * 根据 UID 获取用户资料。
 * 同一 uid 在列表行、详情作者、可信查询卡片间共用缓存；`queryToken` 变化时强制重查一次。
 */
export function useUserProfile(uid: string | undefined, queryToken?: number) {
  const query = useQuery({
    queryKey: userKeys.profile(uid ?? ""),
    queryFn: () => UserAPI.getUserProfile(uid!).then((r) => r.data),
    enabled: Boolean(uid),
    staleTime: PROFILE_STALE_TIME,
  });
  useRefetchOnToken(query.refetch, queryToken);
  return query;
}

/** 可信查询：某用户作为买方 / 卖方的已完成委托数（接口为昨日快照，非实时） */
export function useCompletedOrderCount(uid: string | undefined, queryToken?: number) {
  const query = useQuery({
    queryKey: userKeys.completedOrderCount(uid ?? ""),
    queryFn: async () => {
      const { data } = await OrdersAPI.getCompletedOrderCount(uid!);
      return {
        as_buyer: Number(data.as_buyer) || 0,
        as_seller: Number(data.as_seller) || 0,
      };
    },
    enabled: Boolean(uid),
  });
  useRefetchOnToken(query.refetch, queryToken);
  return query;
}
